export enum SearchEntityKind {
  Publisher = 'publisher',
  Placement = 'placement',
  DemandPartner = 'demandPartner',
  Integration = 'integration',
}

export interface SearchResult {
  kind: SearchEntityKind;
  id: string;
  label: string;
  sublabel?: string | undefined;
  to: string;
  params: Record<string, string>;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC_PATTERN = /^\d+$/;

export function isIdLikeSearchTerm(term: string): boolean {
  const trimmed = term.trim();
  if (!trimmed) return false;
  return UUID_PATTERN.test(trimmed) || NUMERIC_PATTERN.test(trimmed);
}
